// extracted by mini-css-extract-plugin
var _1 = "MU0hM";
export { _1 as "base" }
